import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Params } from '@angular/router';
import { ViewTableComponent } from 'src/app/components/base/view-table/view-table.component';
import { ViewPaymentsFromEnrollmentComponent } from 'src/app/components/forms/view-payments-from-enrollment/view-payments-from-enrollment.component';
import { ViewPaymentsDueFromEnrollmentComponent } from 'src/app/components/forms/view-payments-due-from-enrollment/view-payments-due-from-enrollment.component';
import { EnrollmentEntityComponent } from 'src/app/components/forms/enrollment-entity/enrollment-entity.component';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import moment from 'moment';
import { DialogService } from 'src/app/services/dialog.service';
import { AuthService } from 'src/app/services/auth.service';
import { LessonAdjustmentDialogComponent } from 'src/app/components/forms/lesson-adjustment-dialog/lesson-adjustment-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { RefreshService } from 'src/app/services/refresh.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { UtilityService } from 'src/app/services/utility.service';
import { FieldsService } from 'src/app/services/fields.service';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef, ElementRef, Renderer2 } from '@angular/core';
import { StudioTaxService, StudioTaxMode, enrollmentWithTax } from 'src/app/services/studio-tax.service';
import { Subscription } from 'rxjs';
import { LoggerService } from '../../../../../services/logger.service';

@Component({
  selector: 'app-lesson-student-report',
  templateUrl: './lesson-student-report.component.html',
  styleUrls: ['./lesson-student-report.component.css']
})
export class LessonStudentReportComponent extends ViewTableComponent implements OnInit, OnDestroy {

  @Input() drupal_studentAccount_id: number;
  @Input() drupal_student_name: string;
  @Input() enrollmentsToLoad: string;
  @Input() enrollmentDialogHandler: (component: any, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}, callback?: () => void) => void;
  @Output() dataRefreshed = new EventEmitter<void>();

  constructor(
    refreshService: RefreshService,
    dialogService: DialogService,
    entityRESTService: EntityRESTService,
    utilityService: UtilityService,
    fieldsService: FieldsService,
    drupalRESTService: DrupalRESTService,
    taxonomyService: TaxonomyService,
    router: Router,
    activatedRoute: ActivatedRoute,
    authRESTService: AuthRESTService,
    authService: AuthService,
    menuRESTService: MenuRESTService,
    formBuilder: FormBuilder,
    routeEventsService: RouteEventsService,
    permissionsService: PermissionsService,
    renderer2: Renderer2,
    configPages: ConfigPagesService,
    packagesService: PackagesService,
    snackBar: MatSnackBar,
    userRESTService: UserService,
    el: ElementRef,
    changeDetectorRef: ChangeDetectorRef,
    sanitizer: DomSanitizer,
    studioConfigService: StudioConfigService,
    componentRefreshService: ComponentRefreshService,
    translateService: TranslateService,
    private dialog: MatDialog,
    private studioTaxService: StudioTaxService
  ) {
    super(
      refreshService,
      dialogService,
      entityRESTService,
      utilityService,
      fieldsService,
      drupalRESTService,
      taxonomyService,
      router,
      activatedRoute,
      authRESTService,
      authService,
      menuRESTService,
      formBuilder,
      routeEventsService,
      permissionsService,
      renderer2,
      configPages,
      packagesService,
      snackBar,
      userRESTService,
      el,
      changeDetectorRef,
      sanitizer,
      studioConfigService,
      componentRefreshService,
      translateService
    );
    // Exclusive-tax studios (Canadian GST/HST/PST) see tax-inclusive totals so the
    // dashboard matches what the customer owes/paid; re-annotate if the mode
    // resolves after the rows did.
    this.taxModeSubscription = this.studioTaxService.getTaxMode().subscribe(mode => {
      this.taxMode = mode;
      this.annotateWithTax(this.dataSource?.data);
    });
  }

  // getTaxMode() is backed by a long-lived BehaviorSubject; an open subscription
  // would keep this component (and its rows) alive after the dashboard closes.
  private taxModeSubscription: Subscription;

  override ngOnDestroy(): void {
    this.taxModeSubscription?.unsubscribe();
    super.ngOnDestroy();
  }

  /** Studio tax mode; null until the studio's tax config has loaded. */
  taxMode: StudioTaxMode | null = null;

  /**
   * Attach `withTax` {total, paid, due, totalTax, paidTax, dueTax} to each
   * row, or null when nothing to add. Rows carry paid_tax_actual /
   * paid_gross_actual from /api/v1/enrollment-list, so the paid tax reflects
   * what the payments really collected instead of a rate proration (which
   * can land a cent off: $7,499.99 instead of $7,500.00).
   */
  private annotateWithTax(rows: any[] | undefined): void {
    if (!rows) return;
    rows.forEach(row => {
      row.withTax = row.isAdjustmentRow ? null : enrollmentWithTax(row, this.taxMode);
    });
  }

  sendNonUnitPrivateParam = false;
  sendNonUnitGroupParam = false;

  ViewPaymentsFromEnrollmentComponent = ViewPaymentsFromEnrollmentComponent;
  ViewPaymentsDueFromEnrollmentComponent = ViewPaymentsDueFromEnrollmentComponent;
  override EnrollmentEntityComponent = EnrollmentEntityComponent;

  override displayedColumns: string[] = [
    'enrollmentID',
    // 'field_contacts',
    'field_sale_date',
    'field_instructor',
    'field_category',
    'field_package_name',
    'field_enrollment_lesson_count',
    'field_enrollment_total_price',
    'field_total_paid',
    'field_balance_due',
    // 'field_additional_notes',
    'field_lesson_available',
    'isDropped',
    // 'nothing',
    'nothing_1',
  ];

  override getData(params: { parameter: string; value: string; }[]) {
    // Show Progress Bar (Loading indicator)
    this.ShowProgressBar = true;
    this.queryParams = params;

    let override_params = [
      { parameter: 'field_category_target_id', value: this.enrollmentsToLoad },
      { parameter: 'id', value: this.drupal_studentAccount_id+'' },
      { parameter: 'items_per_page', value: 'All' },
    ]

    // Conditional Parameter Addition
    if (this.sendNonUnitPrivateParam) {
      override_params.push({ parameter: 'field_lesson_type_target_id', value: '1411'});
      // override_params.push({ parameter: 'field_package_code_target_id', value: '173'});
    }
    // Conditional Parameter Addition
    if (this.sendNonUnitGroupParam) {
      override_params.push({ parameter: 'field_lesson_type_target_id', value: '1410'});
      // override_params.push({ parameter: 'field_package_code_target_id', value: '173'});
    }

    // Add sorting paramaters, if available.
    if (this.sortParams !== undefined) {
      this.queryParams.push(this.sortParams)
    }

    // Load the new data with the filtering parameters.
    this._utilityService.getEnrollmentyView(
      this.queryParams.concat(override_params)
    )
      .subscribe((data) => {
        // ShowProgressBar
        this.ShowProgressBar = false;

        this.data = data;

        // Process data to add dropped enrollment rows
        const processedData = this.processDroppedEnrollments(data['results']);
        this.annotateWithTax(processedData);
        this.dataSource = new MatTableDataSource(processedData);

        // Pagination
        if (data?.['results'] && this.paginator) {
          // this.paginator.length = data['count'];
          // this.paginator.pageSize = this.pageSize;
          // this.paginator.pageIndex = this.paginationIndex;
          this.paginator.length = data?.['count'] ?? 0;
          this.paginator.pageSize = data?.['count'] ?? 0;
          this.paginator.pageIndex = 0;
        }
      },
        error => this.handleError(error)
      )
  }

  /**
   * Process dropped enrollments to add adjustment rows
   */
  processDroppedEnrollments(enrollments: any[]): any[] {
    if (!enrollments || enrollments.length === 0) {
      return [];
    }

    const processedData = [...enrollments];
    let insertOffset = 0; // Track how many rows we've inserted

    // Find dropped enrollments and create adjustment rows
    enrollments.forEach((enrollment, index) => {
      if (enrollment.field_dropped_date) {
        // Create a single adjustment row for this dropped enrollment
        const adjustmentRow = { ...enrollment };

        // Mark as an adjustment row
        adjustmentRow.isAdjustmentRow = true;
        adjustmentRow.showTotals = true;

        // Ensure the adjustment row is also marked as a dropped enrollment
        // This will help with styling consistency
        adjustmentRow.field_dropped_date = enrollment.field_dropped_date;

        // Generate a unique ID for the adjustment row
        adjustmentRow.id = `${enrollment.id}-adjustment`;

        // Special handling for miscellaneous enrollments (category 5)
        // Note: Need to use both '5' and 5 in comparisons since the field can be either string or number
        const isMiscellaneous = enrollment.field_category === '5' || enrollment.field_category === 5;
        const isSundry = enrollment.field_category === '67' || enrollment.field_category === 67;
        const isSpecialCategory = isMiscellaneous || isSundry;

        const lessonsUsed = enrollment.field_lesson_used ? parseInt(enrollment.field_lesson_used) : 0;
        const totalLessons = parseInt(enrollment.field_enrollment_lesson_count) || (isSpecialCategory ? 1 : 0);
        const unusedLessons = isSpecialCategory ? 1 : (totalLessons - lessonsUsed);

        // Calculate the per-lesson price (handle special case for category 5)
        const totalPrice = parseFloat(enrollment.field_enrollment_total_price);
        const lessonPrice = isSpecialCategory ? totalPrice : (totalPrice / (totalLessons || 1));

        // Store original values for display
        adjustmentRow.originalLessonCount = isSpecialCategory ? "1" : enrollment.field_enrollment_lesson_count;
        adjustmentRow.originalTotalPrice = enrollment.field_enrollment_total_price;
        adjustmentRow.originalTotalPaid = enrollment.field_total_payments_made;
        adjustmentRow.originalBalanceDue = enrollment.field_balance_due;

        // Set the adjustment values (only subtract the unused lessons)
        const adjustmentLessonCount = isSpecialCategory ? "-1" : `-${unusedLessons}`;

        // Calculate the price for unused lessons
        const unusedLessonsPrice = (unusedLessons * lessonPrice).toFixed(2);
        const adjustmentTotalPrice = isSpecialCategory ? `-${totalPrice.toFixed(2)}` : `-${unusedLessonsPrice}`;

        // Calculate adjustments for payments and balance due
        let adjustmentTotalPaid = "0";
        let adjustmentBalanceDue = "0";

        // Determine if payment was made only for lessons taken or for all lessons
        const isByTheLesson = enrollment.field_payments_structure_type === "By The Lesson";

        // Check if the amount paid corresponds to lessons taken or total lessons
        let paidForLessonsTaken = false;

        if (enrollment.field_total_payments_made) {
          const totalPaid = parseFloat(enrollment.field_total_payments_made);
          const expectedPaymentForUsedLessons = lessonsUsed * lessonPrice;

          // If the payment is close to the expected payment for used lessons (within $1 to account for rounding)
          // or if it's a "By The Lesson" payment structure, assume they paid only for lessons taken
          paidForLessonsTaken = Math.abs(totalPaid - expectedPaymentForUsedLessons) < 1 || isByTheLesson;

          // For cases where they paid only for lessons taken
          if (paidForLessonsTaken) {
            // No adjustment needed for payments
            adjustmentTotalPaid = "0";
          } else {
            // For cases where they paid for all lessons, calculate proportional adjustment
            // For miscellaneous enrollments, we need to refund the entire amount
            if (isSpecialCategory) {
              adjustmentTotalPaid = `-${totalPaid.toFixed(2)}`;
            } else {
              const paidPerLesson = totalPaid / totalLessons;
              const unusedPaid = (unusedLessons * paidPerLesson).toFixed(2);
              adjustmentTotalPaid = `-${unusedPaid}`;
            }
          }
        }

        if (enrollment.field_balance_due) {
          const balanceDue = parseFloat(enrollment.field_balance_due);

          // If they paid only for lessons taken, the balance due is likely for unused lessons
          if (paidForLessonsTaken) {
            // The balance due should be reduced by the full amount of unused lessons
            if (isSpecialCategory) {
              adjustmentBalanceDue = `-${balanceDue.toFixed(2)}`;
            } else {
              const unusedDue = (unusedLessons * lessonPrice).toFixed(2);
              adjustmentBalanceDue = `-${unusedDue}`;
            }
          } else {
            // For other cases, calculate proportional adjustment
            if (isSpecialCategory) {
              adjustmentBalanceDue = `-${balanceDue.toFixed(2)}`;
            } else {
              const duePerLesson = balanceDue / totalLessons;
              const unusedDue = (unusedLessons * duePerLesson).toFixed(2);
              adjustmentBalanceDue = `-${unusedDue}`;
            }
          }
        }

        // Calculate final values after adjustment
        const finalLessonCount = isSpecialCategory ? 0 : lessonsUsed;
        const finalTotalPrice = isSpecialCategory ? "0.00" : (parseFloat(enrollment.field_enrollment_total_price) - parseFloat(unusedLessonsPrice)).toFixed(2);

        let finalTotalPaid = "0.00";
        if (isSpecialCategory) {
          finalTotalPaid = "0.00";
        } else if (!paidForLessonsTaken && enrollment.field_total_payments_made) {
          const totalPaid = parseFloat(enrollment.field_total_payments_made);
          const paidPerLesson = totalPaid / totalLessons;
          const usedPaid = (lessonsUsed * paidPerLesson).toFixed(2);
          finalTotalPaid = usedPaid;
        } else if (paidForLessonsTaken && enrollment.field_total_payments_made) {
          finalTotalPaid = enrollment.field_total_payments_made;
        }

        let finalBalanceDue = "0";
        if (isSpecialCategory) {
          finalBalanceDue = "0.00";
        } else if (paidForLessonsTaken) {
          // For cases where they paid only for lessons taken, calculate balance due for lessons taken but not paid
          const lessonsTakenNotPaid = lessonsUsed - (parseFloat(enrollment.field_total_payments_made || "0") / lessonPrice);
          finalBalanceDue = (lessonsTakenNotPaid > 0 ? lessonsTakenNotPaid * lessonPrice : 0).toFixed(2);
        } else if (enrollment.field_balance_due) {
          const balanceDue = parseFloat(enrollment.field_balance_due);
          const duePerLesson = balanceDue / totalLessons;
          const usedDue = (lessonsUsed * duePerLesson).toFixed(2);
          finalBalanceDue = usedDue;
        }

        // Store adjustment and final values
        adjustmentRow.adjustmentLessonCount = adjustmentLessonCount;
        adjustmentRow.adjustmentTotalPrice = adjustmentTotalPrice;
        adjustmentRow.adjustmentTotalPaid = adjustmentTotalPaid;
        adjustmentRow.adjustmentBalanceDue = adjustmentBalanceDue;

        adjustmentRow.finalLessonCount = finalLessonCount;
        adjustmentRow.finalTotalPrice = finalTotalPrice;
        adjustmentRow.finalTotalPaid = finalTotalPaid;
        adjustmentRow.finalBalanceDue = finalBalanceDue;

        // Set lessons available to 0 for the adjustment
        adjustmentRow.field_lesson_available = "0";

        // Insert the adjustment row immediately after the dropped enrollment
        // We need to account for previously inserted rows, so we use the original index + offset
        processedData.splice(index + insertOffset + 1, 0, adjustmentRow);
        insertOffset++;
      }
    });

    return processedData;
  }

  updateGetData() {
    // Assuming other parts of the component rely on getData with updated state
    this.getData(this.queryParams);
  }

  /**
   * Opens the enrollment dialog with pre-populated instructor and executive fields
   */
  openEnrollment() {
    if (!this.drupal_studentAccount_id || !this.drupal_student_name) {
      LoggerService.error('Student account ID or display name is undefined');
      this._snackBar.open('Unable to open enrollment: Student information is missing', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        panelClass: ['warning-snackbar']
      });
      return;
    }

    // First, get the student account data
    this._entityRESTService.getEntity('student_accounts', 'student_account', this.drupal_studentAccount_id)
      .subscribe(
        studentData => {
          const fieldsData = {
            field_student: `${this.drupal_student_name} (${this.drupal_studentAccount_id})`,
            field_executive: studentData?.['field_executive']?.uid || '',
            // field_sale_date deliberately not prefilled: the enrollment form
            // fills it with studio-timezone "now" when the field is focused,
            // and the expiration date auto-derives from it (+6 months).
            field_enrollment_status: 'Open',
            field_visibility: false
          };

          LoggerService.log('Enrollment fields data:', fieldsData);

          // Open the dialog using the dialog service directly to get the MatDialogRef
          const dialogRef = this._dialogService.openDialog(
            EnrollmentEntityComponent,
            "enrollmentFormWithData",
            {
              data: {
                EntityID: null,
                eckType: 'packages',
                bundle: 'enrollment',
                action: 'create',
                fieldsData: fieldsData,
              },
            }
          );

          // Subscribe to the afterOpened observable
          dialogRef.afterOpened().subscribe(() => {
            // Get the component instance from the dialogRef
            const enrollmentComponent = dialogRef.componentInstance as EnrollmentEntityComponent;
            if (enrollmentComponent && enrollmentComponent.enrollmentForm) {
              this.setInstructorPercentages(enrollmentComponent, studentData);
            }
          });

          // Subscribe to the afterClosed observable to refresh the data
          dialogRef.afterClosed().subscribe(() => {
            this.getData(this.queryParams);
            // Emit event to notify parent component that enrollment was saved
            this.dataRefreshed.emit();
          });
        },
        error => {
          LoggerService.error('Error fetching student data:', error);
          this._snackBar.open('Error preparing enrollment form. Please try again.', 'Close', {
            duration: 3000,
            horizontalPosition: 'center',
            panelClass: ['error-snackbar']
          });
        }
      );
  }

  // Override the openEntityComponent to emit event after enrollment dialog closes
  override openEntityComponent(component: any, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}) {
    // If this is an enrollment and we have a custom handler from parent, use it
    if (eckType === 'packages' && bundle === 'enrollment' && this.enrollmentDialogHandler) {
      this.enrollmentDialogHandler(component, eckType, bundle, action, EntityID, fieldsData, () => {
        // Callback to refresh local data after enrollment dialog closes
        // Use empty array for queryParams since the important params come from override_params in getData()
        this.getData([]);
      });
      return;
    }

    // Otherwise use default behavior
    // Enrollment form needs the wider dialog to match the "Add Enrollment" button on the Enrollment List.
    const dialogConfig = component === EnrollmentEntityComponent ? "enrollmentFormWithData" : "defaultWithData";
    this._dialogService.openDialog(component, dialogConfig, {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
      },
    }).afterClosed().subscribe(data => {
      // Refresh the enrollment data
      this.getData(this.queryParams);
      // Emit event to notify parent component
      this.dataRefreshed.emit();
    });
  }

  // Override the openEntityComponentXL to emit event after dialog closes
  override openEntityComponentXL(component: any, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}) {
    this._dialogService.openDialog(component, "defaultXL", {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
      },
    }).afterClosed().subscribe(data => {
      // Refresh the enrollment data
      this.getData(this.queryParams);
      // Emit event to notify parent component
      this.dataRefreshed.emit();
    });
  }

  /**
   * Sets the instructor percentages in the enrollment form
   */
  private setInstructorPercentages(enrollmentComponent: EnrollmentEntityComponent, studentData: any) {
    if (studentData?.['field_teacher']?.uid) {
      const instructorPercentagesArray = enrollmentComponent.enrollmentForm.get('field_instructor_percentages') as FormArray;

      // Clear existing entries
      while (instructorPercentagesArray.length !== 0) {
        instructorPercentagesArray.removeAt(0);
      }

      // Add new entry
      const newInstructorPercentage = this._formBuilder.group({
        id: [null],
        field_amount: [null],
        field_instructor: [studentData['field_teacher'].uid, Validators.required],
        field_percentage: [100, Validators.required],
        field_studio_reference: [this._authService.selectedStudio?.id],
        bundle: ['instructor_percentages', Validators.required],
        type: ['instructor_percentages', Validators.required],
      });

      instructorPercentagesArray.push(newInstructorPercentage);

      // Trigger change detection
      enrollmentComponent.enrollmentForm.updateValueAndValidity();
      LoggerService.log('Updated enrollment form:', enrollmentComponent.enrollmentForm.value);
    }
  }

  /**
   * Opens the lesson adjustment dialog for an enrollment
   * @param enrollmentId - The enrollment ID to adjust
   */
  openAdjustmentDialog(enrollmentId: string) {
    // Load the full enrollment entity data to get all fields including adjustments
    this._drupalRESTService.httpGET('/packages/' + enrollmentId, [{ parameter: '_format', value: 'json' }])
      .subscribe(fullEnrollmentData => {
        const dialogRef = this.dialog.open(LessonAdjustmentDialogComponent, {
          width: '800px',
          height: 'auto',
          maxHeight: '90vh',
          data: {
            enrollmentId: enrollmentId,
            enrollment: fullEnrollmentData
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // Dialog was saved successfully, refresh the data
            this.getData(this.queryParams);
            // Emit event to notify parent component (student dashboard) to refresh badge info
            this.dataRefreshed.emit();
          }
        });
      }, error => {
        LoggerService.error('Error loading enrollment data:', error);
        // Fallback to using the data from the list view
        const enrollment = this.dataSource.data.find((item: any) => item.id === enrollmentId);

        const dialogRef = this.dialog.open(LessonAdjustmentDialogComponent, {
          width: '800px',
          height: 'auto',
          maxHeight: '90vh',
          data: {
            enrollmentId: enrollmentId,
            enrollment: enrollment
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.getData(this.queryParams);
            // Emit event to notify parent component (student dashboard) to refresh badge info
            this.dataRefreshed.emit();
          }
        });
      });
  }
}
